import React, { Fragment, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { AutoSizer, List } from 'react-virtualized';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const ScrollableDocument = ({ documentIndex, pdfContainerRef, file, onScrollChange, setLastScrollTop, lastScrollTop }) => {

    const [{ numPages, pageHeight, scale }, setPdfSettings] = useState({
        numPages: undefined,
        pageHeight: undefined,
        scale: undefined,
    });
    const handleLoadedDocumentLoadSuccess = async (pdfObject, width) => {
        const page = await pdfObject.getPage(1);
        const viewPort = page.getViewport();
        const pageHeight = viewPort.viewBox[3] * (width / viewPort.viewBox[2]);
        setPdfSettings({ numPages: pdfObject.numPages, pageHeight, scale: width / viewPort.viewBox[2] });
    };
    const handleScroll = ({ clientHeight, scrollHeight, scrollTop }) => {
        setLastScrollTop(scrollTop)
        lastScrollTop !== 0 && onScrollChange({
            documentIndex,
            hasScrolledToBottom: scrollTop + clientHeight >= scrollHeight - 5,
            hasScrolledOutsideOfDocumentActions: scrollTop + clientHeight < scrollHeight - 100,
        });
    };

    const rowRenderer = ({ key, index, style }) => (
        <span key={key} style={style}>
            <Page
                scale={scale}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                loading=""
                pageNumber={index + 1}
            />
        </span>
    );

    return (
        <AutoSizer>
            {({ height, width }) => (
                <Fragment>
                    {!!width && width > 0 && (
                        <Fragment>
                            <div ref={pdfContainerRef}>
                                <Document
                                    file={file || ''}
                                    loading=""
                                    onLoadSuccess={pdfObject => handleLoadedDocumentLoadSuccess(pdfObject, width)}
                                >
                                    {numPages && (
                                        <List
                                            height={height}
                                            rowCount={numPages}
                                            rowHeight={pageHeight}
                                            rowRenderer={rowRenderer}
                                            width={width}
                                            overscanRowCount={1}
                                            onScroll={handleScroll}
                                        />
                                    )}
                                </Document>
                            </div>
                        </Fragment>
                    )}
                </Fragment>
            )}
        </AutoSizer>
    );
};
